import { __assign, __makeTemplateObject, __rest } from "tslib";
import { jsx as _jsx } from "react/jsx-runtime";
import { useCallback, useRef, useState, useEffect } from 'react';
import * as React from 'react';
import classnames from 'classnames';
import capitalize from 'lodash/capitalize';
import styled from 'styled-components';
import { customScroll, noScroll } from '../theme/mixins';
import { useForkRef } from '../utils/withForwardedRef';
var Root = styled.div.withConfig({
  displayName: "ui-kit-Root",
  componentId: "ui-kit-bhspf2"
})(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  padding: 8px 32px 16px;\n  flex: 1 1 auto;\n  -webkit-overflow-scrolling: touch;\n  overflow-y: auto;\n  margin-bottom: 24px;\n\n  ", "\n\n  &.noScrollbar {\n    ", "\n  }\n\n  &.paddingLarge {\n    padding: 8px 48px 16px;\n  }\n\n  &.borderBottom {\n    border-bottom: 1px solid ", ";\n  }\n\n  &.borderTop {\n    border-top: 1px solid ", ";\n  }\n"], ["\n  padding: 8px 32px 16px;\n  flex: 1 1 auto;\n  -webkit-overflow-scrolling: touch;\n  overflow-y: auto;\n  margin-bottom: 24px;\n\n  ", "\n\n  &.noScrollbar {\n    ", "\n  }\n\n  &.paddingLarge {\n    padding: 8px 48px 16px;\n  }\n\n  &.borderBottom {\n    border-bottom: 1px solid ", ";\n  }\n\n  &.borderTop {\n    border-top: 1px solid ", ";\n  }\n"])), function (_a) {
  var theme = _a.theme;
  return customScroll({
    backgroundColor: theme.palette.background.neutral.primary
  });
}, noScroll(), function (_a) {
  var theme = _a.theme;
  return theme.palette.divider.primary;
}, function (_a) {
  var theme = _a.theme;
  return theme.palette.divider.primary;
});
var DialogContent = React.forwardRef(function (_a, ref) {
  var className = _a.className,
      _b = _a.paddingSize,
      paddingSize = _b === void 0 ? 'normal' : _b,
      onScroll = _a.onScroll,
      noScrollbar = _a.noScrollbar,
      otherProps = __rest(_a, ["className", "paddingSize", "onScroll", "noScrollbar"]);

  var _c = useState([]),
      scrollClass = _c[0],
      setScrollClass = _c[1];

  var rootClassName = classnames("padding".concat(capitalize(paddingSize)), className, scrollClass, {
    noScrollbar: noScrollbar
  });
  var innerRef = useRef(null);
  var handleRef = useForkRef(ref, innerRef);
  var getClasses = useCallback(function () {
    var _a = innerRef.current,
        scrollHeight = _a.scrollHeight,
        clientHeight = _a.clientHeight,
        scrollTop = _a.scrollTop;
    var classes = [];

    if (scrollTop > 0) {
      classes.push('borderTop');
    }

    if (scrollHeight - clientHeight > scrollTop) {
      classes.push('borderBottom');
    }

    setScrollClass(classes);
  }, []);
  var handleScroll = useCallback(function (e) {
    onScroll === null || onScroll === void 0 ? void 0 : onScroll(e);
    getClasses();
  }, [getClasses, onScroll]);
  useEffect(getClasses, [getClasses]);
  useEffect(function () {
    window.addEventListener('resize', getClasses);
    return function () {
      return window.removeEventListener('resize', getClasses);
    };
  }, [getClasses]);
  return _jsx(Root, __assign({
    className: rootClassName,
    ref: handleRef,
    onScroll: handleScroll
  }, otherProps));
});
export default React.memo(DialogContent);
var templateObject_1;